module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "ded"
  }, [_c('p', {
    staticClass: "newchap",
    attrs: {
      "id": "_idParaDest-2"
    }
  }, [_c('a', {
    attrs: {
      "id": "Road-Tripping-and-Picnicking"
    }
  }), _vm._v("Road Tripping and Picnicking")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('img', {
    staticClass: "_idGenPageitem-1",
    attrs: {
      "alt": "",
      "src": "image/Picnic_Basket.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "pagebreak"
  }), _vm._v(" "), _c('div', {
    staticClass: "ded"
  }, [_c('p', {
    staticClass: "subTOC"
  }, [_c('a', {
    attrs: {
      "href": "#/#Sunny-Orange-and-Cilantro-Couscous"
    }
  }, [_vm._v("Sunny Orange and Cilantro Couscous")])]), _vm._v(" "), _c('p', {
    staticClass: "subTOC"
  }, [_c('a', {
    attrs: {
      "href": "#/#Technicolor-Rama-Asian-Slaw"
    }
  }, [_vm._v("Technicolor-Rama Asian Slaw")])]), _vm._v(" "), _c('p', {
    staticClass: "subTOC"
  }, [_c('a', {
    attrs: {
      "href": "#/#Gussied-Up-Pimento-Cheese-Finger-Sandwiches"
    }
  }, [_vm._v("Gussied-Up Pimento Cheese Finger Sandwiches")])]), _vm._v(" "), _c('p', {
    staticClass: "subTOC"
  }, [_c('a', {
    attrs: {
      "href": "#/#Pimento-Cheese-with-a-Kick"
    }
  }, [_vm._v("Pimento Cheese with a Kick")])]), _vm._v(" "), _c('p', {
    staticClass: "subTOC"
  }, [_c('a', {
    attrs: {
      "href": "#/#Pickled-Jalape-o-Pimento-Cheese"
    }
  }, [_vm._v("Pickled Jalapeño Pimento Cheese")])]), _vm._v(" "), _c('p', {
    staticClass: "subTOC"
  }, [_c('a', {
    attrs: {
      "href": "#/#Pimento-Cheese-a-la--Little-Switzerland"
    }
  }, [_vm._v("Pimento Cheese a la Little Switzerland")])]), _vm._v(" "), _c('p', {
    staticClass: "subTOC"
  }, [_c('a', {
    attrs: {
      "href": "#/#Summertime-Tomato-Salad"
    }
  }, [_vm._v("Summertime Tomato Salad")])]), _vm._v(" "), _c('p', {
    staticClass: "subTOC"
  }, [_c('a', {
    attrs: {
      "href": "#/#Caprese-Salad"
    }
  }, [_vm._v("Caprese Salad")])]), _vm._v(" "), _c('p', {
    staticClass: "subTOC"
  }, [_c('a', {
    attrs: {
      "href": "#/#Roast-Beef-Po--Boy"
    }
  }, [_vm._v("Roast Beef Po’ Boy")])]), _vm._v(" "), _c('p', {
    staticClass: "subTOC"
  }, [_c('a', {
    attrs: {
      "href": "#/#Smoked-Sunburst-Trout-Dip"
    }
  }, [_vm._v("Smoked Sunburst Trout Dip")])]), _vm._v(" "), _c('p', {
    staticClass: "subTOC"
  }, [_c('a', {
    attrs: {
      "href": "#/#Really--Really--Really-Great-Guacamole"
    }
  }, [_vm._v("Really, Really, Really Great Guacamole")])]), _vm._v(" "), _c('p', {
    staticClass: "subTOC"
  }, [_c('a', {
    attrs: {
      "href": "#/#Blue-Ridge-Mountain-Deviled-Egg-Salad"
    }
  }, [_vm._v("Blue Ridge Mountain Deviled Egg Salad")])])]), _vm._v(" "), _c('p', {
    staticClass: "pagebreak"
  }), _vm._v(" "), _c('p', {
    staticClass: "chquote"
  }, [_c('a', {
    attrs: {
      "id": "ham2"
    }
  }), _vm._v("Springtime in the mountains is a true reawakening for all the senses, and picnics are a great way to enjoy the lovely light green of the landscape. The end of winter also means the arrival of spring thunderstorms. One Native American saying suggests thunder means God is “breaking the backbone of winter.”")]), _vm._v(" "), _c('p', {
    staticClass: "chquoteatt"
  }, [_vm._v("—Joe Dabney")]), _vm._v(" "), _c('p', {
    staticClass: "basic"
  }), _vm._v(" "), _c('p', {
    staticClass: "chtext"
  }, [_c('span', {
    staticClass: "greencap"
  }, [_vm._v("O")]), _vm._v("nce upon a time, not so long ago, you were encouraged to “drive the USA in your Chevrolet,” an early invocation to pack the kids in the car and strike out to discover America by automobile. It’s still a popular pastime and a great way to explore, connect with one another, and learn about history, tradition, culture, food, and people. One of the most popular road trips in the United States—and certainly in the mountain South—is along the 469-mile Blue Ridge Parkway, a scenic drive traversing the spine of the Appalachian Mountains. The road affords unforgettable, breathtaking, sweeping mountain panoramas, as well as historical and cultural finds around every turn. ")]), _vm._v(" "), _c('p', {
    staticClass: "chtext"
  }, [_vm._v("There’s no better way to experience the engineering genius of the Blue Ridge Parkway—with its stone tunnels and bridges, its dogtrot cabins, its mind-boggling vistas—than to drive the entire road, from Rockfish Gap, Virginia, to Cherokee, North Carolina. To do it justice, you should allow three or four days, giving yourself permission to stop anywhere you wish, linger, ask questions, and enjoy a picnic. This is a road that isn’t about getting from point A to point B, after all; it’s a road that’s all about enjoying the journey. ")]), _vm._v(" "), _c('p', {
    staticClass: "chtext"
  }, [_vm._v("Lots of folks in the region also enjoy brief jaunts, day trips, cycling excursions, hikes, and afternoon drives along the parkway, and we see lots of them in our Asheville restaurants, either having some Sweet Potato Pancakes before striking out for a parkway experience, or at the end of the day, settling in with a plate of our "), _c('a', {
    attrs: {
      "href": "#/52249txt7#Not-Your-Mama-s-Meat-Loaf-with-Tomato-Rosemary-Gravy"
    }
  }, [_vm._v("Not Your Mama’s Meat Loaf with Tomato Rosemary Gravy")]), _vm._v(" and a cold beer. Parkway travel often includes a picnic lunch or late afternoon sunset picnic, so we’re devoting this chapter to some flavorful ways to pack your picnic basket. Nothing’s quite as spectacular as enjoying a "), _c('a', {
    attrs: {
      "href": "#/#Summertime-Tomato-Salad"
    }
  }, [_vm._v("Summertime Tomato Salad")]), _vm._v(" or a "), _c('a', {
    attrs: {
      "href": "#/#Pickled-Jalape-o-Pimento-Cheese"
    }
  }, [_vm._v("Pickled Jalapeño Pimento Cheese")]), _vm._v(" sandwich while perched on one of our favorite top-of-the-world spots, overlooking the Blue Ridge. ")]), _vm._v(" "), _c('p', {
    staticClass: "chtext"
  }, [_vm._v("We think a way to really connect with the parkway is to incorporate food and food traditions from the surrounding communities and farms, so when you’re enjoying the Blue Ridge Parkway, be sure you take your time and pull off to explore local-resident farm stands, country stores, and hometown meat-and-threes. ")]), _vm._v(" "), _c('p', {
    staticClass: "pagebreak"
  }), _c('p', {
    staticClass: "rectitle"
  }, [_c('span', {
    staticClass: "green"
  }, [_c('a', {
    attrs: {
      "id": "Sunny-Orange-and-Cilantro-Couscous"
    }
  }), _vm._v("Sunny Orange and Cilantro Couscous")])]), _vm._v(" "), _c('p', {
    staticClass: "headnote"
  }, [_vm._v("While couscous was once a pretty exotic ingredient in the South, it’s now omnipresent in just about any Food City, Piggly Wiggly, or Jitney-Jungle in the region. This take on the beloved Middle Eastern and Mediterranean staple adds a little citrus, a little poblano, and a hint of cilantro for a simple but decidedly unexpected version of couscous perfect with grilled chicken or fish.")]), _vm._v(" "), _c('p', {
    staticClass: "yield"
  }, [_c('span', {
    staticClass: "orange"
  }, [_vm._v("Makes 5½ cups, or 6 to 8 servings")])]), _vm._v(" "), _c('p', {
    staticClass: "ingred"
  }, [_c('span', {
    staticClass: "orange"
  }, [_vm._v("2¼ cups orange juice ")])]), _vm._v(" "), _c('p', {
    staticClass: "ingred"
  }, [_c('span', {
    staticClass: "orange"
  }, [_vm._v("2 cups water")])]), _vm._v(" "), _c('p', {
    staticClass: "ingred"
  }, [_c('span', {
    staticClass: "orange"
  }, [_vm._v("1½ teaspoons kosher salt ")])]), _vm._v(" "), _c('p', {
    staticClass: "ingred"
  }, [_c('span', {
    staticClass: "orange"
  }, [_vm._v("2 cups Israeli pearl couscous")])]), _vm._v(" "), _c('p', {
    staticClass: "ingred"
  }, [_c('span', {
    staticClass: "orange"
  }, [_c('span', {
    staticClass: "super"
  }, [_vm._v("2")]), _vm._v("/"), _c('span', {
    staticClass: "sub"
  }, [_vm._v("3")]), _vm._v(" cup finely diced red bell pepper")])]), _vm._v(" "), _c('p', {
    staticClass: "ingred"
  }, [_c('span', {
    staticClass: "orange"
  }, [_c('span', {
    staticClass: "super"
  }, [_vm._v("1")]), _vm._v("/"), _c('span', {
    staticClass: "sub"
  }, [_vm._v("3")]), _vm._v(" cup finely diced poblano pepper")])]), _vm._v(" "), _c('p', {
    staticClass: "ingred"
  }, [_c('span', {
    staticClass: "orange"
  }, [_c('span', {
    staticClass: "super"
  }, [_vm._v("1")]), _vm._v("/"), _c('span', {
    staticClass: "sub"
  }, [_vm._v("3")]), _vm._v(" cup finely diced red onion")])]), _vm._v(" "), _c('p', {
    staticClass: "ingred"
  }, [_c('span', {
    staticClass: "orange"
  }, [_vm._v("1 cup canned mandarin orange segments, drained")])]), _vm._v(" "), _c('p', {
    staticClass: "ingred"
  }, [_c('span', {
    staticClass: "orange"
  }, [_vm._v("2 tablespoons extra-virgin olive oil")])]), _vm._v(" "), _c('p', {
    staticClass: "ingred"
  }, [_c('span', {
    staticClass: "orange"
  }, [_vm._v("1 tablespoon minced fresh cilantro")])]), _vm._v(" "), _c('p', {
    staticClass: "ingred"
  }, [_c('span', {
    staticClass: "orange"
  }, [_vm._v("1 tablespoon minced fresh parsley")])]), _vm._v(" "), _c('p', {
    staticClass: "ingred"
  }, [_c('span', {
    staticClass: "orange"
  }, [_vm._v("½ teaspoon freshly ground black pepper")])]), _vm._v(" "), _c('p', {
    staticClass: "ingred"
  }, [_c('span', {
    staticClass: "orange"
  }, [_vm._v("Pinch of white pepper")])]), _vm._v(" "), _c('p', {
    staticClass: "method"
  }, [_vm._v("Place 2 cups of the orange juice and 2 cups water in a medium saucepan and bring to a boil. Add 1 teaspoon of the salt and stir in the couscous. Lower the heat to maintain a low boil and cook until tender, about 6 minutes. Drain and place in a large bowl, discarding the cooking liquid. ")]), _vm._v(" "), _c('p', {
    staticClass: "method"
  }, [_vm._v("Add the remaining ¼ cup orange juice, the red bell pepper, poblano pepper, onion, mandarin orange segments, olive oil, cilantro, parsley, black pepper, white pepper, and the remaining ½ teaspoon salt to the couscous, mixing the ingredients thoroughly. Cover and refrigerate until ready to serve. Serve at room temperature or slightly chilled. ")]), _vm._v(" "), _c('p', {
    staticClass: "pagebreak"
  }), _c('p', {
    staticClass: "rectitle"
  }, [_c('span', {
    staticClass: "green"
  }, [_c('a', {
    attrs: {
      "id": "Technicolor-Rama-Asian-Slaw"
    }
  }), _vm._v("Technicolor-Rama Asian Slaw")])]), _vm._v(" "), _c('p', {
    staticClass: "headnote"
  }, [_vm._v("This colorful explosion of flavors is the perfect complement to barbecue, fried chicken, grilled pork, or fish. It’s also a fantastic addition to our Appalachian Egg Rolls (see the "), _c('a', {
    attrs: {
      "href": "#/52249txt6#Appalachian-Egg-Rolls-with-Smoked-Jalape-o-Sauce--Pickled-Onions--and-Pulled-Pork"
    }
  }, [_vm._v("Appalachian Egg Rolls with Smoked Jalapeño Sauce, Pickled Onions, and Pulled Pork")]), _vm._v(" recipe). With its mixture of red and green cabbages, bok choy, carrots, jicama, and apple, this is a side chock-full of nutrients and vitamins, not to mention the zing of fresh ginger. This is one vegetable concoction that is not only good for you, but pretty on the table as well.")]), _vm._v(" "), _c('p', {
    staticClass: "yield"
  }, [_c('span', {
    staticClass: "orange"
  }, [_vm._v("Makes 6 servings")])]), _vm._v(" "), _c('p', {
    staticClass: "ingred"
  }, [_c('span', {
    staticClass: "orange"
  }, [_vm._v("3 cups shredded green cabbage")])]), _vm._v(" "), _c('p', {
    staticClass: "ingred"
  }, [_c('span', {
    staticClass: "orange"
  }, [_vm._v("1½ cups shredded red cabbage")])]), _vm._v(" "), _c('p', {
    staticClass: "ingred"
  }, [_c('span', {
    staticClass: "orange"
  }, [_vm._v("1 cup thinly sliced bok choy")])]), _vm._v(" "), _c('p', {
    staticClass: "ingred"
  }, [_c('span', {
    staticClass: "orange"
  }, [_vm._v("½ cup coarsely shredded carrots")])]), _vm._v(" "), _c('p', {
    staticClass: "ingred"
  }, [_c('span', {
    staticClass: "orange"
  }, [_vm._v("½ cup julienned jicama")])]), _vm._v(" "), _c('p', {
    staticClass: "ingred"
  }, [_c('span', {
    staticClass: "orange"
  }, [_vm._v("½ cup finely diced Granny Smith apple")])]), _vm._v(" "), _c('p', {
    staticClass: "ingred"
  }, [_c('span', {
    staticClass: "orange"
  }, [_vm._v("¼ cup finely chopped fresh cilantro")])]), _vm._v(" "), _c('p', {
    staticClass: "ingred"
  }, [_c('span', {
    staticClass: "orange"
  }, [_vm._v("Dressing (recipe follows)")])]), _vm._v(" "), _c('p', {
    staticClass: "method"
  }, [_vm._v("Place the shredded cabbages, the bok choy, carrots, jicama, apple, and cilantro in a large bowl. Pour the slaw dressing over the mixture and toss well. Cover and refrigerate for 1 hour before serving, stirring occasionally. ")]), _vm._v(" "), _c('p', {
    staticClass: "pagebreak"
  }), _c('p', {
    staticClass: "rectitle"
  }, [_c('span', {
    staticClass: "green"
  }, [_c('a', {
    attrs: {
      "id": "Dressing"
    }
  }), _vm._v("Dressing")])]), _vm._v(" "), _c('p', {
    staticClass: "yield"
  }, [_c('span', {
    staticClass: "orange"
  }, [_vm._v("Makes about 1 cup")])]), _vm._v(" "), _c('p', {
    staticClass: "ingred"
  }, [_c('span', {
    staticClass: "orange"
  }, [_vm._v("½ cup sugar")])]), _vm._v(" "), _c('p', {
    staticClass: "ingred"
  }, [_c('span', {
    staticClass: "orange"
  }, [_vm._v("¼ cup red wine vinegar")])]), _vm._v(" "), _c('p', {
    staticClass: "ingred"
  }, [_c('span', {
    staticClass: "orange"
  }, [_vm._v("¼ cup cider vinegar")])]), _vm._v(" "), _c('p', {
    staticClass: "ingred"
  }, [_c('span', {
    staticClass: "orange"
  }, [_vm._v("2 teaspoons soy sauce")])]), _vm._v(" "), _c('p', {
    staticClass: "ingred"
  }, [_c('span', {
    staticClass: "orange"
  }, [_vm._v("2 teaspoons finely minced fresh ginger")])]), _vm._v(" "), _c('p', {
    staticClass: "ingred"
  }, [_c('span', {
    staticClass: "orange"
  }, [_vm._v("1 teaspoon freshly squeezed lemon juice")])]), _vm._v(" "), _c('p', {
    staticClass: "ingred"
  }, [_c('span', {
    staticClass: "orange"
  }, [_vm._v("¼ teaspoon crushed red pepper")])]), _vm._v(" "), _c('p', {
    staticClass: "ingred"
  }, [_c('span', {
    staticClass: "orange"
  }, [_vm._v("¼ teaspoon salt")])]), _vm._v(" "), _c('p', {
    staticClass: "ingred"
  }, [_c('span', {
    staticClass: "orange"
  }, [_c('span', {
    staticClass: "super"
  }, [_vm._v("1")]), _vm._v("/"), _c('span', {
    staticClass: "sub"
  }, [_vm._v("8")]), _vm._v(" teaspoon freshly ground black pepper")])]), _vm._v(" "), _c('p', {
    staticClass: "method"
  }, [_vm._v("Combine the sugar, vinegars, soy sauce, ginger, lemon juice, crushed red pepper, salt, and black pepper in a pint jar. Cover and shake to dissolve the sugar. Refrigerate in an airtight container for up to 1 week. ")]), _vm._v(" "), _c('p', {
    staticClass: "pagebreak"
  }), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('img', {
    staticClass: "_idGenPageitem-1",
    attrs: {
      "alt": "",
      "src": "image/TH_04_Techni_Asian_Slaw_v2_082.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "pagebreak"
  }), _c('p', {
    staticClass: "rectitle"
  }, [_c('span', {
    staticClass: "green"
  }, [_c('a', {
    attrs: {
      "id": "Gussied-Up-Pimento-Cheese-Finger-Sandwiches"
    }
  }), _vm._v("Gussied-Up Pimento Cheese Finger Sandwiches")])]), _vm._v(" "), _c('p', {
    staticClass: "headnote"
  }, [_vm._v("On a warm day, these flavorful pimento cheese finger sandwiches will hit the spot at any picnic. The addition of crisp, refreshing cucumber and quality sourdough bread is the trick. Keep these refrigerated if you make them in advance, or if you’re assembling the sandwiches on a picnic blanket, be sure you keep the pimento cheese on ice until you’re ready to use it. ")]), _vm._v(" "), _c('p', {
    staticClass: "yield"
  }, [_c('span', {
    staticClass: "orange"
  }, [_vm._v("Makes 4 finger sandwiches")])]), _vm._v(" "), _c('p', {
    staticClass: "ingred"
  }, [_c('span', {
    staticClass: "orange"
  }, [_vm._v("2 tablespoons pimento cheese (see the "), _c('a', {
    attrs: {
      "href": "#/#Pimento-Cheese-with-a-Kick"
    }
  }, [_vm._v("Pimento Cheese with a Kick")]), _vm._v(" recipe)")])]), _vm._v(" "), _c('p', {
    staticClass: "ingred"
  }, [_c('span', {
    staticClass: "orange"
  }, [_vm._v("Two ½-inch to ¾-inch-thick slices artisanal sourdough bread")])]), _vm._v(" "), _c('p', {
    staticClass: "ingred"
  }, [_c('span', {
    staticClass: "orange"
  }, [_vm._v("8 thin lengthwise slices peeled English cucumber, sized to fit the bread")])]), _vm._v(" "), _c('p', {
    staticClass: "ingred"
  }, [_c('span', {
    staticClass: "orange"
  }, [_vm._v("¼ cup alfalfa sprouts")])]), _vm._v(" "), _c('p', {
    staticClass: "ingred"
  }, [_c('span', {
    staticClass: "orange"
  }, [_vm._v("Pinch of sea salt")])]), _vm._v(" "), _c('p', {
    staticClass: "ingred"
  }, [_c('span', {
    staticClass: "orange"
  }, [_vm._v("Pinch of freshly ground black pepper")])]), _vm._v(" "), _c('p', {
    staticClass: "ingred"
  }, [_c('span', {
    staticClass: "orange"
  }, [_vm._v("Toothpicks")])]), _vm._v(" "), _c('p', {
    staticClass: "method"
  }, [_vm._v("Spread 1 tablespoon of the pimento cheese on each slice of bread to the edges. Arrange 4 slices of cucumber on each bread slice. Place the sprouts on 1 of the bread slices and season to taste with salt and pepper. Sandwich together the 2 halves, cut into 4 triangles, and secure with toothpicks. ")]), _vm._v(" "), _c('p', {
    staticClass: "pagebreak"
  }), _c('p', {
    staticClass: "rectitle"
  }, [_c('span', {
    staticClass: "green"
  }, [_c('a', {
    attrs: {
      "id": "Pimento-Cheese-with-a-Kick"
    }
  }), _vm._v("Pimento Cheese with a Kick")])]), _vm._v(" "), _c('p', {
    staticClass: "headnote"
  }, [_vm._v("Pimento cheese has the capacity to be chameleon-like. The traditional recipes, like your mom used to make, are terrific, but sometimes you just need to cut loose a little and mix up something that will wake up everybody’s taste buds. The addition of pickled cherry peppers and fresh cilantro will evoke an unanticipated “wow,” followed by a “yum,” followed by a request for a little more.")]), _vm._v(" "), _c('p', {
    staticClass: "yield"
  }, [_c('span', {
    staticClass: "orange"
  }, [_vm._v("Makes 4¾ cups")])]), _vm._v(" "), _c('p', {
    staticClass: "ingred"
  }, [_c('span', {
    staticClass: "orange"
  }, [_vm._v("4 cups (1 pound) shredded sharp cheddar cheese")])]), _vm._v(" "), _c('p', {
    staticClass: "ingred"
  }, [_c('span', {
    staticClass: "orange"
  }, [_vm._v("4 pickled cherry peppers, seeded and minced")])]), _vm._v(" "), _c('p', {
    staticClass: "ingred"
  }, [_c('span', {
    staticClass: "orange"
  }, [_vm._v("1 cup diced red bell peppers")])]), _vm._v(" "), _c('p', {
    staticClass: "ingred"
  }, [_c('span', {
    staticClass: "orange"
  }, [_vm._v("1 tablespoon minced fresh parsley")])]), _vm._v(" "), _c('p', {
    staticClass: "ingred"
  }, [_c('span', {
    staticClass: "orange"
  }, [_vm._v("1 tablespoon minced fresh cilantro")])]), _vm._v(" "), _c('p', {
    staticClass: "ingred"
  }, [_c('span', {
    staticClass: "orange"
  }, [_vm._v("1 cup mayonnaise (we prefer Duke’s)")])]), _vm._v(" "), _c('p', {
    staticClass: "ingred"
  }, [_c('span', {
    staticClass: "orange"
  }, [_vm._v("1 tablespoon Dijon mustard")])]), _vm._v(" "), _c('p', {
    staticClass: "ingred"
  }, [_c('span', {
    staticClass: "orange"
  }, [_vm._v("1 tablespoon whole-grain Dijon mustard")])]), _vm._v(" "), _c('p', {
    staticClass: "ingred"
  }, [_c('span', {
    staticClass: "orange"
  }, [_vm._v("1 teaspoon dry mustard")])]), _vm._v(" "), _c('p', {
    staticClass: "ingred"
  }, [_c('span', {
    staticClass: "orange"
  }, [_vm._v("1 teaspoon ground cumin")])]), _vm._v(" "), _c('p', {
    staticClass: "ingred"
  }, [_c('span', {
    staticClass: "orange"
  }, [_vm._v("½ teaspoon ground coriander")])]), _vm._v(" "), _c('p', {
    staticClass: "ingred"
  }, [_c('span', {
    staticClass: "orange"
  }, [_vm._v("½ teaspoon freshly ground black pepper")])]), _vm._v(" "), _c('p', {
    staticClass: "method"
  }, [_vm._v("Combine the cheese, cherry peppers, red bell peppers, parsley, and cilantro in a large bowl and toss to blend. Stir in the mayonnaise, Dijon, whole-grain Dijon, dry mustard, cumin, coriander, and black pepper. Mix well and refrigerate in an airtight container for at least 1 hour before serving. ")]), _vm._v(" "), _c('div', {
    staticClass: "sidebar"
  }, [_c('p', {
    staticClass: "SBT"
  }, [_vm._v("Ramps ("), _c('span', {
    staticClass: "SBTitalic"
  }, [_c('em', [_vm._v("Allium tricoccum")])]), _vm._v(") are one of the best-loved mountain specialties. Growing at higher elevations in Appalachia, the ramp has characteristics of both garlic and onion, and they are delicious fried and served with potatoes and eggs or pickled and served with a skillet of cornbread and some country ham.")])]), _vm._v(" "), _c('p', {
    staticClass: "pagebreak"
  }), _c('p', {
    staticClass: "rectitle"
  }, [_c('span', {
    staticClass: "green"
  }, [_c('a', {
    attrs: {
      "id": "Pickled-Jalape-o-Pimento-Cheese"
    }
  }), _vm._v("Pickled Jalapeño Pimento Cheese")])]), _vm._v(" "), _c('p', {
    staticClass: "headnote"
  }, [_vm._v("Olé! This is delicious served with tortilla chips or atop a hamburger. Our Shoo Mercy Sheer Bliss Burger, which we serve in the restaurant as a seasonal special, is a kissing cousin to this idea: It’s our famous burger plus fried green tomatoes, pimento cheese, bacon, and fried pickled jalapeño peppers. We are not kidding.")]), _vm._v(" "), _c('p', {
    staticClass: "yield"
  }, [_c('span', {
    staticClass: "orange"
  }, [_vm._v("Makes 3 cups")])]), _vm._v(" "), _c('p', {
    staticClass: "ingred"
  }, [_c('span', {
    staticClass: "orange"
  }, [_vm._v("4 cups (1 pound) shredded cheddar cheese")])]), _vm._v(" "), _c('p', {
    staticClass: "ingred"
  }, [_c('span', {
    staticClass: "orange"
  }, [_vm._v("1 cup mayonnaise (we like Duke’s)")])]), _vm._v(" "), _c('p', {
    staticClass: "ingred"
  }, [_c('span', {
    staticClass: "orange"
  }, [_vm._v("1 tablespoon Dijon mustard")])]), _vm._v(" "), _c('p', {
    staticClass: "ingred"
  }, [_c('span', {
    staticClass: "orange"
  }, [_vm._v("1 tablespoon whole-grain Dijon mustard")])]), _vm._v(" "), _c('p', {
    staticClass: "ingred"
  }, [_c('span', {
    staticClass: "orange"
  }, [_vm._v("½ teaspoon freshly ground black pepper")])]), _vm._v(" "), _c('p', {
    staticClass: "ingred"
  }, [_c('span', {
    staticClass: "orange"
  }, [_vm._v("1 teaspoon freshly squeezed lemon juice")])]), _vm._v(" "), _c('p', {
    staticClass: "ingred"
  }, [_c('span', {
    staticClass: "orange"
  }, [_vm._v("1 tablespoon minced fresh parsley")])]), _vm._v(" "), _c('p', {
    staticClass: "ingred"
  }, [_c('span', {
    staticClass: "orange"
  }, [_vm._v("1 tablespoon minced fresh cilantro")])]), _vm._v(" "), _c('p', {
    staticClass: "ingred"
  }, [_c('span', {
    staticClass: "orange"
  }, [_vm._v("1 teaspoon ground cumin")])]), _vm._v(" "), _c('p', {
    staticClass: "ingred"
  }, [_c('span', {
    staticClass: "orange"
  }, [_vm._v("½ teaspoon ground coriander")])]), _vm._v(" "), _c('p', {
    staticClass: "ingred"
  }, [_c('span', {
    staticClass: "orange"
  }, [_vm._v("4 pickled jalapeño peppers, stemmed, seeded, and minced")])]), _vm._v(" "), _c('p', {
    staticClass: "ingred"
  }, [_c('span', {
    staticClass: "orange"
  }, [_vm._v("1 cup diced roasted red bell peppers")])]), _vm._v(" "), _c('p', {
    staticClass: "method"
  }, [_vm._v("Combine the cheddar cheese, mayonnaise, Dijon, whole-grain Dijon, black pepper, lemon juice, parsley, cilantro, cumin, coriander, jalapeño peppers, and roasted red bell peppers in a large bowl. Blend well and refrigerate in an airtight container for up to 1 week.")]), _vm._v(" "), _c('p', {
    staticClass: "pagebreak"
  }), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('img', {
    staticClass: "_idGenPageitem-1",
    attrs: {
      "alt": "",
      "src": "image/IMG_2601.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "pagebreak"
  }), _c('p', {
    staticClass: "rectitle"
  }, [_c('span', {
    staticClass: "green"
  }, [_c('a', {
    attrs: {
      "id": "Pimento-Cheese-a-la--Little-Switzerland"
    }
  }), _vm._v("Pimento Cheese a la Little Switzerland")])]), _vm._v(" "), _c('p', {
    staticClass: "headnote"
  }, [_vm._v("We consider ourselves pretty knowledgeable about good pimento cheese, since we go through a ton of it in the restaurant. This variety is inspired by a sweet little community right on the Blue Ridge Parkway, just north of Asheville—Little Switzerland, North Carolina—complete with Swiss chalets overlooking the mountains. It’s an Appalachian salute to the Alps.")]), _vm._v(" "), _c('p', {
    staticClass: "yield"
  }, [_c('span', {
    staticClass: "orange"
  }, [_vm._v("Makes 2½ cups")])]), _vm._v(" "), _c('p', {
    staticClass: "ingred"
  }, [_c('span', {
    staticClass: "orange"
  }, [_vm._v("2 cups (8 ounces) shredded Swiss cheese")])]), _vm._v(" "), _c('p', {
    staticClass: "ingred"
  }, [_c('span', {
    staticClass: "orange"
  }, [_vm._v("½ cup (2 ounces) shredded Gruyère cheese")])]), _vm._v(" "), _c('p', {
    staticClass: "ingred"
  }, [_c('span', {
    staticClass: "orange"
  }, [_vm._v("½ cup plus 2 tablespoons Duke’s mayonnaise")])]), _vm._v(" "), _c('p', {
    staticClass: "ingred"
  }, [_c('span', {
    staticClass: "orange"
  }, [_vm._v("½ cup finely diced roasted red bell peppers from a jar")])]), _vm._v(" "), _c('p', {
    staticClass: "ingred"
  }, [_c('span', {
    staticClass: "orange"
  }, [_vm._v("¼ cup whole-grain Dijon mustard")])]), _vm._v(" "), _c('p', {
    staticClass: "ingred"
  }, [_c('span', {
    staticClass: "orange"
  }, [_vm._v("1 tablespoon chopped fresh parsley")])]), _vm._v(" "), _c('p', {
    staticClass: "ingred"
  }, [_c('span', {
    staticClass: "orange"
  }, [_vm._v("1 tablespoon chopped fresh herbs in any combination—oregano, sage, thyme, or basil")])]), _vm._v(" "), _c('p', {
    staticClass: "ingred"
  }, [_c('span', {
    staticClass: "orange"
  }, [_vm._v("¾ teaspoon dry mustard")])]), _vm._v(" "), _c('p', {
    staticClass: "ingred"
  }, [_c('span', {
    staticClass: "orange"
  }, [_vm._v("¼ teaspoon freshly squeezed lemon juice")])]), _vm._v(" "), _c('p', {
    staticClass: "ingred"
  }, [_c('span', {
    staticClass: "orange"
  }, [_vm._v("¼ teaspoon freshly ground black pepper")])]), _vm._v(" "), _c('p', {
    staticClass: "method"
  }, [_vm._v("In a large bowl, combine the cheeses, mayonnaise, roasted red bell peppers, Dijon mustard, herbs, dry mustard, lemon juice, and black pepper, stirring until well blended. Serve with crackers or crostini. Or warm this up in the microwave or oven and serve it with some rustic, crusty bread. Store in an airtight container in the refrigerator for up to 1 week.")]), _vm._v(" "), _c('div', {
    staticClass: "sidebar"
  }, [_c('p', {
    staticClass: "SBT"
  }, [_vm._v("A favorite stopping off spot along the Blue Ridge Parkway is Mabry’s Mill, a functioning gristmill located at Milepost 176.2, between Roanoke and Galax, Virginia. You can see blacksmithing demonstrations and chair making, spinning and weaving, and, of course, grinding. You can then walk next door to the adjacent restaurant and enjoy sweet potato or buckwheat pancakes. Buckwheat, a popular food staple in the mountain South, is not a grain; it is a fruit seed related to rhubarb and sorrel, so it’s a great gluten-free choice.")])]), _vm._v(" "), _c('p', {
    staticClass: "pagebreak"
  }), _c('p', {
    staticClass: "rectitle"
  }, [_c('span', {
    staticClass: "green"
  }, [_c('a', {
    attrs: {
      "id": "Summertime-Tomato-Salad"
    }
  }), _vm._v("Summertime Tomato Salad")])]), _vm._v(" "), _c('p', {
    staticClass: "headnote"
  }, [_vm._v("During the height of tomato season in the South, heirloom varieties are considered cause for celebration. “Now this is what a tomato should taste like!” people say. And they’re right. Here’s a simple salad that takes the perfection of ripe old-fashioned tomatoes and arranges them tastefully (and simply) on a platter. If you can find them, the addition of delicious Green Zebras will have your guests talking long after they go home.")]), _vm._v(" "), _c('p', {
    staticClass: "yield"
  }, [_c('span', {
    staticClass: "orange"
  }, [_vm._v("Makes 6 servings")])]), _vm._v(" "), _c('p', {
    staticClass: "ingred"
  }, [_c('span', {
    staticClass: "orange"
  }, [_vm._v("2 medium cucumbers")])]), _vm._v(" "), _c('p', {
    staticClass: "ingred"
  }, [_c('span', {
    staticClass: "orange"
  }, [_vm._v("3 large heirloom tomatoes, each cut into 8 wedges")])]), _vm._v(" "), _c('p', {
    staticClass: "ingred"
  }, [_c('span', {
    staticClass: "orange"
  }, [_vm._v("3 Green Zebra or medium-size yellow heirloom tomatoes, cut into quarters")])]), _vm._v(" "), _c('p', {
    staticClass: "ingred"
  }, [_c('span', {
    staticClass: "orange"
  }, [_vm._v("1 small red onion, cut lengthwise into very thin strips")])]), _vm._v(" "), _c('p', {
    staticClass: "ingred"
  }, [_c('span', {
    staticClass: "orange"
  }, [_c('span', {
    staticClass: "super"
  }, [_vm._v("1")]), _vm._v("/"), _c('span', {
    staticClass: "sub"
  }, [_vm._v("3")]), _vm._v(" to ¼ cup well-shaken Tomato Salad Vinaigrette (recipe follows) ")])]), _vm._v(" "), _c('p', {
    staticClass: "method"
  }, [_vm._v("Using a vegetable peeler, shave off half of each cucumber’s peel in strips and discard. Cut the cucumbers in half lengthwise, scraping out the seeds using a teaspoon. Cut the cucumber halves into 2- to 3-inch julienne strips. ")]), _vm._v(" "), _c('p', {
    staticClass: "method"
  }, [_vm._v("Arrange the tomatoes and cucumber and red onion strips on a serving platter. Drizzle with the vinaigrette and serve immediately. ")]), _vm._v(" "), _c('div', {
    staticClass: "sidebar"
  }, [_c('p', {
    staticClass: "SBT"
  }, [_vm._v("After a long winter, the arrival of seasonal greens in the springtime is cause for celebration. Look for lamb’s-quarters (wild spinach), cressies, comfrey, sorrel, dandelion, purslane, nettles, poke sallet, and rhubarb or “dock.” At our restaurants, we serve New South Greens, made with Swiss chard, kale, and garlic oil.")])]), _vm._v(" "), _c('p', {
    staticClass: "pagebreak"
  }), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('img', {
    staticClass: "_idGenPageitem-1",
    attrs: {
      "alt": "",
      "src": "image/TH_17_Tomato_Salad_205.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "pagebreak"
  }), _c('p', {
    staticClass: "rectitle"
  }, [_c('span', {
    staticClass: "green"
  }, [_c('a', {
    attrs: {
      "id": "Tomato-Salad-Vinaigrette"
    }
  }), _vm._v("Tomato Salad Vinaigrette")])]), _vm._v(" "), _c('p', {
    staticClass: "yield"
  }, [_c('span', {
    staticClass: "orange"
  }, [_vm._v("Makes 2 cups")])]), _vm._v(" "), _c('p', {
    staticClass: "ingred"
  }, [_c('span', {
    staticClass: "orange"
  }, [_vm._v("2 tablespoons Chopped Garlic in Oil (recipe follows)")])]), _vm._v(" "), _c('p', {
    staticClass: "ingred"
  }, [_c('span', {
    staticClass: "orange"
  }, [_vm._v("1 tablespoon chopped fresh basil")])]), _vm._v(" "), _c('p', {
    staticClass: "ingred"
  }, [_c('span', {
    staticClass: "orange"
  }, [_vm._v("1 teaspoon chopped fresh rosemary")])]), _vm._v(" "), _c('p', {
    staticClass: "ingred"
  }, [_c('span', {
    staticClass: "orange"
  }, [_vm._v("1 teaspoon chopped fresh oregano")])]), _vm._v(" "), _c('p', {
    staticClass: "ingred"
  }, [_c('span', {
    staticClass: "orange"
  }, [_vm._v("1 teaspoon chopped fresh thyme leaves")])]), _vm._v(" "), _c('p', {
    staticClass: "ingred"
  }, [_c('span', {
    staticClass: "orange"
  }, [_vm._v("1 teaspoon salt")])]), _vm._v(" "), _c('p', {
    staticClass: "ingred"
  }, [_c('span', {
    staticClass: "orange"
  }, [_vm._v("½ teaspoon freshly ground black pepper")])]), _vm._v(" "), _c('p', {
    staticClass: "ingred"
  }, [_c('span', {
    staticClass: "orange"
  }, [_vm._v("¾ cup red wine vinegar")])]), _vm._v(" "), _c('p', {
    staticClass: "ingred"
  }, [_c('span', {
    staticClass: "orange"
  }, [_vm._v("1 cup extra-virgin olive oil")])]), _vm._v(" "), _c('p', {
    staticClass: "method"
  }, [_vm._v("Combine the Chopped Garlic in Oil, basil, rosemary, oregano, thyme, salt, and pepper in a blender. Pour in the vinegar and cover and process until the herbs are finely minced, about 10 seconds. With the blender running, gradually pour the olive oil into the center opening at the top of the blender, processing for about 5 seconds, or until the dressing is emulsified. Keep in an airtight container in the refrigerator for up to 30 days.")]), _vm._v(" "), _c('p', {
    staticClass: "pagebreak"
  }), _c('p', {
    staticClass: "rectitle"
  }, [_c('span', {
    staticClass: "green"
  }, [_c('a', {
    attrs: {
      "id": "Chopped-Garlic-in-Oil"
    }
  }), _vm._v("Chopped Garlic in Oil")])]), _vm._v(" "), _c('p', {
    staticClass: "yield"
  }, [_c('span', {
    staticClass: "orange"
  }, [_vm._v("Makes ½ cup")])]), _vm._v(" "), _c('p', {
    staticClass: "ingred"
  }, [_c('span', {
    staticClass: "orange"
  }, [_vm._v("½ cup peeled cloves garlic")])]), _vm._v(" "), _c('p', {
    staticClass: "ingred"
  }, [_c('span', {
    staticClass: "orange"
  }, [_vm._v("¼ cup extra-virgin olive oil")])]), _vm._v(" "), _c('p', {
    staticClass: "method"
  }, [_vm._v("With the food processor running, drop the garlic through the food chute and process for 5 to 8 seconds, until the garlic is minced. Add the oil and pulse 3 to 4 times, until well combined. Store in an airtight container in the refrigerator for up to 1 week. ")]), _vm._v(" "), _c('p', {
    staticClass: "pagebreak"
  }), _c('p', {
    staticClass: "rectitle"
  }, [_c('span', {
    staticClass: "green"
  }, [_c('a', {
    attrs: {
      "id": "Caprese-Salad"
    }
  }), _vm._v("Caprese Salad")])]), _vm._v(" "), _c('p', {
    staticClass: "headnote"
  }, [_vm._v("Take full advantage of ripe heirloom tomatoes (of all colors, sizes, and tastes) as well as the pop-in-your-mouth sweet grape or Sun Gold varieties with this timeless salad. Shakespeare wasn’t talking about tomatoes when he said “The ripeness is all.” But he could have been. ")]), _vm._v(" "), _c('p', {
    staticClass: "yield"
  }, [_c('span', {
    staticClass: "orange"
  }, [_vm._v("Makes 4 servings")])]), _vm._v(" "), _c('p', {
    staticClass: "ingred"
  }, [_c('span', {
    staticClass: "orange"
  }, [_vm._v("4 medium-size heirloom tomatoes in various colors, each cut into 4 slices")])]), _vm._v(" "), _c('p', {
    staticClass: "ingred"
  }, [_c('span', {
    staticClass: "orange"
  }, [_vm._v("12 (1-ounce) slices fresh mozzarella cheese")])]), _vm._v(" "), _c('p', {
    staticClass: "ingred"
  }, [_c('span', {
    staticClass: "orange"
  }, [_vm._v("14 Sun Gold or grape tomatoes, halved")])]), _vm._v(" "), _c('p', {
    staticClass: "ingred"
  }, [_c('span', {
    staticClass: "orange"
  }, [_vm._v("¼ cup extra-virgin olive oil")])]), _vm._v(" "), _c('p', {
    staticClass: "ingred"
  }, [_c('span', {
    staticClass: "orange"
  }, [_vm._v("¼ cup Balsamic Reduction (recipe follows)")])]), _vm._v(" "), _c('p', {
    staticClass: "ingred"
  }, [_c('span', {
    staticClass: "orange"
  }, [_vm._v("¼ teaspoon salt")])]), _vm._v(" "), _c('p', {
    staticClass: "ingred"
  }, [_c('span', {
    staticClass: "orange"
  }, [_vm._v("¼ teaspoon freshly ground black pepper")])]), _vm._v(" "), _c('p', {
    staticClass: "ingred"
  }, [_c('span', {
    staticClass: "orange"
  }, [_vm._v("¼ cup very thinly sliced fresh basil")])]), _vm._v(" "), _c('p', {
    staticClass: "method"
  }, [_vm._v("Layer the tomatoes and mozzarella on serving plates, beginning and ending with the tomatoes. Place the Sun Gold tomatoes on top and around the stacks. Drizzle each with 1 tablespoon of the olive oil and 1 tablespoon of the Balsamic Reduction. Sprinkle the stacks with salt and pepper. Garnish with the basil and serve right away. ")]), _vm._v(" "), _c('p', {
    staticClass: "pagebreak"
  }), _c('p', {
    staticClass: "rectitle"
  }, [_c('span', {
    staticClass: "green"
  }, [_c('a', {
    attrs: {
      "id": "Balsamic-Reduction"
    }
  }), _vm._v("Balsamic Reduction")])]), _vm._v(" "), _c('p', {
    staticClass: "yield"
  }, [_c('span', {
    staticClass: "orange"
  }, [_vm._v("Makes 1 cup")])]), _vm._v(" "), _c('p', {
    staticClass: "ingred"
  }, [_c('span', {
    staticClass: "orange"
  }, [_vm._v("2 cups balsamic vinegar")])]), _vm._v(" "), _c('p', {
    staticClass: "method"
  }, [_vm._v("Put the vinegar into a small pan and simmer over low heat until reduced by half. Cool to room temperature. Do not refrigerate; use immediately. ")]), _vm._v(" "), _c('p', {
    staticClass: "pagebreak"
  }), _c('p', {
    staticClass: "rectitle"
  }, [_c('span', {
    staticClass: "green"
  }, [_c('a', {
    attrs: {
      "id": "Roast-Beef-Po--Boy"
    }
  }), _vm._v("Roast Beef Po’ Boy")])]), _vm._v(" "), _c('p', {
    staticClass: "headnote"
  }, [_vm._v("There’s nothing poor about this country cousin to the New Orleans classic sandwich. We serve ours with Fried Green Tomato and Cherry Pepper Aioli on New Orleans’ Gambino’s French bread. The key to this sandwich is the perfect rare roast on the prime rib, sliced very thinly and served at room temperature. ")]), _vm._v(" "), _c('p', {
    staticClass: "yield"
  }, [_c('span', {
    staticClass: "orange"
  }, [_vm._v("Makes 1 sandwich")])]), _vm._v(" "), _c('p', {
    staticClass: "ingred"
  }, [_c('span', {
    staticClass: "orange"
  }, [_vm._v("1 (5-inch) piece good French bread, such as Gambino’s")])]), _vm._v(" "), _c('p', {
    staticClass: "ingred"
  }, [_c('span', {
    staticClass: "orange"
  }, [_vm._v("2 slices cheddar cheese")])]), _vm._v(" "), _c('p', {
    staticClass: "ingred"
  }, [_c('span', {
    staticClass: "orange"
  }, [_vm._v("¼ cup Cherry Pepper Aioli (recipe follows)")])]), _vm._v(" "), _c('p', {
    staticClass: "ingred"
  }, [_c('span', {
    staticClass: "orange"
  }, [_vm._v("2 large or 3 small "), _c('a', {
    attrs: {
      "href": "#/52249txt5#Fried-Green-Tomatoes"
    }
  }, [_vm._v("Fried Green Tomatoes")]), _vm._v(" slices")])]), _vm._v(" "), _c('p', {
    staticClass: "ingred"
  }, [_c('span', {
    staticClass: "orange"
  }, [_vm._v("5 ounces shaved prime rib (see "), _c('a', {
    attrs: {
      "href": "#/52249txt7#Tupelo-Honey-Roast-Prime-Rib"
    }
  }, [_vm._v("Tupelo Honey Roast Prime Rib")]), _vm._v("; or you can also use shaved deli roast beef)")])]), _vm._v(" "), _c('p', {
    staticClass: "ingred"
  }, [_c('span', {
    staticClass: "orange"
  }, [_vm._v("2 to 3 romaine lettuce leaves, shredded")])]), _vm._v(" "), _c('p', {
    staticClass: "method"
  }, [_vm._v("Position the oven rack about 8 inches from the heat source and preheat the oven broiler. Slice the bread in half lengthwise. Arrange the cheese slices on top of the bread. Place the bread halves on a baking sheet, cheese side up, and broil until the cheese melts and is lightly browned, 1 to 2 minutes. ")]), _vm._v(" "), _c('p', {
    staticClass: "method"
  }, [_vm._v("Spread 2 tablespoons of the Cherry Pepper Aioli on each half. Arrange the fried green tomato slices on the bottom half, and top with the prime rib and finally the shredded lettuce. Serve immediately. ")]), _vm._v(" "), _c('p', {
    staticClass: "pagebreak"
  }), _c('p', {
    staticClass: "rectitle"
  }, [_c('span', {
    staticClass: "green"
  }, [_c('a', {
    attrs: {
      "id": "Cherry-Pepper-Aioli"
    }
  }), _vm._v("Cherry Pepper Aioli")])]), _vm._v(" "), _c('p', {
    staticClass: "yield"
  }, [_c('span', {
    staticClass: "orange"
  }, [_vm._v("Makes 1½ cups")])]), _vm._v(" "), _c('p', {
    staticClass: "ingred"
  }, [_c('span', {
    staticClass: "orange"
  }, [_vm._v("1 cup mayonnaise")])]), _vm._v(" "), _c('p', {
    staticClass: "ingred"
  }, [_c('span', {
    staticClass: "orange"
  }, [_vm._v("¼ cup cherry peppers")])]), _vm._v(" "), _c('p', {
    staticClass: "ingred"
  }, [_c('span', {
    staticClass: "orange"
  }, [_vm._v("1 tablespoon lemon juice")])]), _vm._v(" "), _c('p', {
    staticClass: "ingred"
  }, [_c('span', {
    staticClass: "orange"
  }, [_vm._v("1 tablespoon Roasted Garlic Puree (see the "), _c('a', {
    attrs: {
      "href": "#/52249txt3#Roasted-Garlic-Puree"
    }
  }, [_vm._v("Roasted Garlic Puree and Roasted Garlic Oil")]), _vm._v(" recipe)")])]), _vm._v(" "), _c('p', {
    staticClass: "ingred"
  }, [_c('span', {
    staticClass: "orange"
  }, [_vm._v("½ tablespoon salt")])]), _vm._v(" "), _c('p', {
    staticClass: "ingred"
  }, [_c('span', {
    staticClass: "orange"
  }, [_vm._v("½ tablespoon pepper")])]), _vm._v(" "), _c('p', {
    staticClass: "ingred"
  }, [_c('span', {
    staticClass: "orange"
  }, [_vm._v("1 teaspoon Tabasco sauce")])]), _vm._v(" "), _c('p', {
    staticClass: "method"
  }, [_vm._v("In a bowl, mix the mayonnaise, cherry peppers, lemon juice, garlic puree, salt, pepper, and Tabasco. Combine well and store in an airtight container in the refrigerator for up to 1 week. ")]), _vm._v(" "), _c('p', {
    staticClass: "pagebreak"
  }), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('img', {
    staticClass: "_idGenPageitem-1",
    attrs: {
      "alt": "",
      "src": "image/TH_05_Po_Boy_v4_114.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "pagebreak"
  }), _c('p', {
    staticClass: "rectitle"
  }, [_c('span', {
    staticClass: "green"
  }, [_c('a', {
    attrs: {
      "id": "Smoked-Sunburst-Trout-Dip"
    }
  }), _vm._v("Smoked Sunburst Trout Dip")])]), _vm._v(" "), _c('p', {
    staticClass: "headnote"
  }, [_vm._v("Our friends at Sunburst Trout Farms in Canton, North Carolina, provide us with some of the finest smoked trout in the world. Serve this on crostini or crackers, and pour yourself some champagne or a glass of chilled prosecco. Heaven! ")]), _vm._v(" "), _c('p', {
    staticClass: "yield"
  }, [_c('span', {
    staticClass: "orange"
  }, [_vm._v("Makes 1½ cups")])]), _vm._v(" "), _c('p', {
    staticClass: "ingred"
  }, [_c('span', {
    staticClass: "orange"
  }, [_vm._v("1 (8-ounce) package cream cheese, softened")])]), _vm._v(" "), _c('p', {
    staticClass: "ingred"
  }, [_c('span', {
    staticClass: "orange"
  }, [_vm._v("1 tablespoon freshly squeezed lemon juice")])]), _vm._v(" "), _c('p', {
    staticClass: "ingred"
  }, [_c('span', {
    staticClass: "orange"
  }, [_vm._v("1 tablespoon "), _c('a', {
    attrs: {
      "href": "#/52249txt3#Roasted-Garlic-Puree"
    }
  }, [_vm._v("Roasted Garlic Puree and Roasted Garlic Oil")])])]), _vm._v(" "), _c('p', {
    staticClass: "ingred"
  }, [_c('span', {
    staticClass: "orange"
  }, [_vm._v("¼ pound smoked trout fillet, skin removed, coarsely flaked")])]), _vm._v(" "), _c('p', {
    staticClass: "ingred"
  }, [_c('span', {
    staticClass: "orange"
  }, [_vm._v("1 tablespoon capers, drained")])]), _vm._v(" "), _c('p', {
    staticClass: "ingred"
  }, [_c('span', {
    staticClass: "orange"
  }, [_c('span', {
    staticClass: "super"
  }, [_vm._v("1")]), _vm._v("/"), _c('span', {
    staticClass: "sub"
  }, [_vm._v("8")]), _vm._v(" teaspoon salt")])]), _vm._v(" "), _c('p', {
    staticClass: "ingred"
  }, [_c('span', {
    staticClass: "orange"
  }, [_c('span', {
    staticClass: "super"
  }, [_vm._v("1")]), _vm._v("/"), _c('span', {
    staticClass: "sub"
  }, [_vm._v("8")]), _vm._v(" teaspoon freshly ground black pepper")])]), _vm._v(" "), _c('p', {
    staticClass: "method"
  }, [_vm._v("Combine the cream cheese, lemon juice, and Roasted Garlic Puree in a food processor and process for 30 seconds, or until the mixture is smooth and fluffy. Add the trout, capers, salt, and pepper and pulse the food processor 15 to 16 times, or until the trout is finely flaked and the mixture is well blended. Transfer the dip to a covered container and refrigerate for up to 14 days. Before serving, bring the dip to room temperature.")]), _vm._v(" "), _c('p', {
    staticClass: "pagebreak"
  }), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('img', {
    staticClass: "_idGenPageitem-1",
    attrs: {
      "alt": "",
      "src": "image/IMG_2360.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "pagebreak"
  }), _c('p', {
    staticClass: "rectitle"
  }, [_c('span', {
    staticClass: "green"
  }, [_c('a', {
    attrs: {
      "id": "Really--Really--Really-Great-Guacamole"
    }
  }), _vm._v("Really, Really, Really Great Guacamole ")])]), _vm._v(" "), _c('p', {
    staticClass: "headnote"
  }, [_vm._v("This will inspire you to pull out your sombrero and do a hat dance. While it’s wonderful served with the traditional tortilla chip, try it on your next perfectly grilled burger. With its touch of sour cream and splash of hot sauce, this guacamole is mucho bueno. ")]), _vm._v(" "), _c('p', {
    staticClass: "yield"
  }, [_c('span', {
    staticClass: "orange"
  }, [_vm._v("Makes 2½ cups")])]), _vm._v(" "), _c('p', {
    staticClass: "ingred"
  }, [_c('span', {
    staticClass: "orange"
  }, [_vm._v("3 ripe, slightly soft Haas avocados")])]), _vm._v(" "), _c('p', {
    staticClass: "ingred"
  }, [_c('span', {
    staticClass: "orange"
  }, [_vm._v("Juice of ½ large lime")])]), _vm._v(" "), _c('p', {
    staticClass: "ingred"
  }, [_c('span', {
    staticClass: "orange"
  }, [_c('span', {
    staticClass: "super"
  }, [_vm._v("1")]), _vm._v("/"), _c('span', {
    staticClass: "sub"
  }, [_vm._v("3")]), _vm._v(" cup minced fresh cilantro")])]), _vm._v(" "), _c('p', {
    staticClass: "ingred"
  }, [_c('span', {
    staticClass: "orange"
  }, [_vm._v("¼ cup minced Vidalia onion")])]), _vm._v(" "), _c('p', {
    staticClass: "ingred"
  }, [_c('span', {
    staticClass: "orange"
  }, [_vm._v("1 tablespoon sour cream")])]), _vm._v(" "), _c('p', {
    staticClass: "ingred"
  }, [_c('span', {
    staticClass: "orange"
  }, [_vm._v("1½ teaspoons ground cumin")])]), _vm._v(" "), _c('p', {
    staticClass: "ingred"
  }, [_c('span', {
    staticClass: "orange"
  }, [_vm._v("¼ teaspoon ground coriander")])]), _vm._v(" "), _c('p', {
    staticClass: "ingred"
  }, [_c('span', {
    staticClass: "orange"
  }, [_vm._v("¼ teaspoon dried oregano")])]), _vm._v(" "), _c('p', {
    staticClass: "ingred"
  }, [_c('span', {
    staticClass: "orange"
  }, [_vm._v("¼ teaspoon chili powder")])]), _vm._v(" "), _c('p', {
    staticClass: "ingred"
  }, [_c('span', {
    staticClass: "orange"
  }, [_c('span', {
    staticClass: "super"
  }, [_vm._v("1")]), _vm._v("/"), _c('span', {
    staticClass: "sub"
  }, [_vm._v("8")]), _vm._v(" teaspoon cayenne pepper")])]), _vm._v(" "), _c('p', {
    staticClass: "ingred"
  }, [_c('span', {
    staticClass: "orange"
  }, [_vm._v("½ teaspoon salt")])]), _vm._v(" "), _c('p', {
    staticClass: "ingred"
  }, [_c('span', {
    staticClass: "orange"
  }, [_vm._v("2 dashes of green hot pepper sauce")])]), _vm._v(" "), _c('p', {
    staticClass: "ingred"
  }, [_c('span', {
    staticClass: "orange"
  }, [_vm._v("½ pint cherry tomatoes, cut into quarters")])]), _vm._v(" "), _c('p', {
    staticClass: "method"
  }, [_vm._v("Peel, pit, and chop the avocados in a medium bowl and toss with the lime juice to prevent browning. Mash the mixture coarsely with a pastry blender or fork. Stir in the cilantro, onion, sour cream, cumin, coriander, oregano, chili powder, cayenne, salt, and hot pepper sauce. Gently stir in the tomatoes. Serve at room temperature.")]), _vm._v(" "), _c('p', {
    staticClass: "pagebreak"
  }), _c('p', {
    staticClass: "rectitle"
  }, [_c('span', {
    staticClass: "green"
  }, [_c('a', {
    attrs: {
      "id": "Blue-Ridge-Mountain-Deviled-Egg-Salad"
    }
  }), _vm._v("Blue Ridge Mountain Deviled Egg Salad")])]), _vm._v(" "), _c('p', {
    staticClass: "headnote"
  }, [_vm._v("The addition of a touch of cherry peppers and a dash of cumin sets this gorgeous egg salad apart from the norm. Slather this between two thick slices of sourdough or stuff it in a ripe tomato, and you’ve got a dish worthy of adoration. ")]), _vm._v(" "), _c('p', {
    staticClass: "yield"
  }, [_c('span', {
    staticClass: "orange"
  }, [_vm._v("Makes 3½ cups")])]), _vm._v(" "), _c('p', {
    staticClass: "ingred"
  }, [_c('span', {
    staticClass: "orange"
  }, [_vm._v("12 eggs")])]), _vm._v(" "), _c('p', {
    staticClass: "ingred"
  }, [_c('span', {
    staticClass: "orange"
  }, [_vm._v("1 yellow bell pepper, finely diced")])]), _vm._v(" "), _c('p', {
    staticClass: "ingred"
  }, [_c('span', {
    staticClass: "orange"
  }, [_vm._v("½ cup mayonnaise (we like Duke’s)")])]), _vm._v(" "), _c('p', {
    staticClass: "ingred"
  }, [_c('span', {
    staticClass: "orange"
  }, [_vm._v("1 tablespoon diced hot cherry peppers")])]), _vm._v(" "), _c('p', {
    staticClass: "ingred"
  }, [_c('span', {
    staticClass: "orange"
  }, [_vm._v("1 teaspoon freshly squeezed lemon juice")])]), _vm._v(" "), _c('p', {
    staticClass: "ingred"
  }, [_c('span', {
    staticClass: "orange"
  }, [_vm._v("1 teaspoon dry mustard")])]), _vm._v(" "), _c('p', {
    staticClass: "ingred"
  }, [_c('span', {
    staticClass: "orange"
  }, [_vm._v("1 teaspoon sweet paprika")])]), _vm._v(" "), _c('p', {
    staticClass: "ingred"
  }, [_c('span', {
    staticClass: "orange"
  }, [_vm._v("½ teaspoon ground cumin")])]), _vm._v(" "), _c('p', {
    staticClass: "ingred"
  }, [_c('span', {
    staticClass: "orange"
  }, [_vm._v("½ teaspoon salt")])]), _vm._v(" "), _c('p', {
    staticClass: "ingred"
  }, [_c('span', {
    staticClass: "orange"
  }, [_vm._v("½ teaspoon freshly ground black pepper")])]), _vm._v(" "), _c('p', {
    staticClass: "method"
  }, [_vm._v("Place the eggs in a saucepan and cover them with cold water. Bring to a boil and then remove from the heat, cover, and let stand for 8 minutes. Drain and let cool completely under cold running water. Peel and dice the eggs and put them in a large bowl. ")]), _vm._v(" "), _c('p', {
    staticClass: "method"
  }, [_vm._v("Add the bell pepper, mayonnaise, cherry peppers, lemon juice, dry mustard, paprika, cumin, salt, and pepper to the bowl and stir well to mix. Cover and refrigerate until chilled. The salad will keep for up to 5 days.")]), _vm._v(" "), _c('p', {
    staticClass: "pagebreak"
  }), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('img', {
    staticClass: "_idGenPageitem-1",
    attrs: {
      "alt": "",
      "src": "image/IMG_2521.jpg"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6971eeb1","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/52249txt-2.vue
// module id = 66
// module chunks = 0